export const JOB_STATUS = Object.freeze({
    ACTIVE: 'active',
    ARCHIVED: 'archived',
    DELETED: 'deleted',
});

export const ALL_STATUS_VALUE = 'all';

export const JOB_STATUS_OPTIONS = Object.freeze([
    { id: ALL_STATUS_VALUE, title: 'All', count: 0, isSelected: true },
    { id: JOB_STATUS.ACTIVE, title: 'Active', count: 0, isSelected: false },
    { id: JOB_STATUS.ARCHIVED, title: 'Archived', count: 0, isSelected: false },
]);

export const JOB_LISTING_TYPE = Object.freeze({
    JOB: 'job',
    PIPELINE: 'pipeline',
});
